// extracted by mini-css-extract-plugin
module.exports = {"container":"index-module--container--NaqgQ","heading":"index-module--heading--3IBTq","divider":"index-module--divider--hX37B"};